/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {AccountLayoutComponent as ɵf} from './lib/components/account-layout/account-layout.component';
export {ApplicationLayoutComponent as ɵe} from './lib/components/application-layout/application-layout.component';
export {EmptyLayoutComponent as ɵg} from './lib/components/empty-layout/empty-layout.component';
export {NG_ALAIN_THEME_STYLES_PROVIDERS as ɵi,configureStyles as ɵj} from './lib/providers/styles.provider';
export {LANG as ɵa,LANG_PROVIDES as ɵb} from './lib/root/providers/lang.provider';
export {STYLES_PROVIDERS as ɵc,configureStyles as ɵd} from './lib/root/providers/styles.provider';
export {RootModule as ɵh} from './lib/root/root.module';